import { createContext, useContext, useEffect, useRef, ReactNode } from 'react';
import { motion, useInView } from 'motion/react';
import { useLocation } from 'react-router-dom';

const StaggerContext = createContext<React.MutableRefObject<number> | null>(null);

export function StaggerGroup({ children }: { children: ReactNode }) {
  const counter = useRef(0);
  const location = useLocation();

  useEffect(() => {
    counter.current = 0;
  }, [location.pathname]);

  return (
    <StaggerContext.Provider value={counter}>
      {children}
    </StaggerContext.Provider>
  );
}

interface StaggerInProps {
  children: ReactNode;
  className?: string;
}

export function StaggerIn({ children, className }: StaggerInProps) {
  const counterRef = useContext(StaggerContext);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-20px' });

  const index = counterRef ? counterRef.current++ : 0;
  const delay = index * 0.04;

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 6 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 6 }}
      transition={{
        duration: 0.22,
        delay,
        ease: [0.16, 1, 0.3, 1],
      }}
    >
      {children}
    </motion.div>
  );
}